import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { httpGetEnums } from "~/services/http/enums";

export const fetchEnumsAsync = createAsyncThunk(
  "enums/fetchEnums",
  async (_, { rejectWithValue }) => {
    try {
      return await httpGetEnums();
    } catch (error) {
      return rejectWithValue({
        statusCode: error.status,
      });
    }
  },
);

const enumsSlice = createSlice({
  name: "enums",
  initialState: { data: {} },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchEnumsAsync.fulfilled, (state, action) => {
      Object.assign(state.data, action.payload);
    });
  },
});

export const getEnums = () => (dispatch) => dispatch(fetchEnumsAsync()).unwrap();

export default enumsSlice.reducer;
